import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Tabs from '../../../components/tabs';
import { getUsersInclusive } from '../../../reducers/users';
import { deleteJob, terminateJob } from '../../../reducers/jobs';
import { getJobs } from '../../../reducers/jobs';
import { getClientWorkers } from '../../../reducers/clients';
import AssignmentTab from '../tabs/assignment';
import BankingTab from '../tabs/banking';
import GeneralTab from '../tabs/general';
import DocumentsTab from '../../../components/lists/workerDocuments';
import { getFullName } from '../../../utilities/string';
import PayStubsTab from '../tabs/paystubs';
import { setImpersonateRole } from '../../../reducers/identity';
import { setRoleSelectorVisibility } from '../../../reducers/dialogs';
import { getJobProjects } from '../../../reducers/timekeeping';
import { getClientsProjects } from '../../../reducers/projects';
import { sendInvite } from '../../../reducers/invites';

class AdminWorker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.deleteJob = this.handleDelete.bind(this);
        this.terminateJob = this.handleTerminate.bind(this);
        this.loadWorkers = this.loadWorkers.bind(this);
        this.inviteUser = this.inviteUser.bind(this);
    }

    componentDidMount() {
        const { clientId, getUsersInclusive, getClientsProjects } = this.props;
        getUsersInclusive({ id: clientId, type: 'client' }, undefined, ['contractor']);
        getClientsProjects(clientId);

        this.loadWorkers();
    }

    loadWorkers() {
        const { clientId, getClientWorkers, contractorId, getJobProjects } = this.props;

        getClientWorkers(clientId, () => true, undefined, result => {
            let job = result.find(w => w.contractor_id === contractorId);
            getJobProjects(job.id);
        });
    }

    inviteUser(values, onFinish) {
        const { sendInvite, clientId, getUsersInclusive } = this.props;
        sendInvite({ ...values, clientId }, { id: clientId, type: 'client' }, () => {
            getUsersInclusive(
                { id: clientId, type: 'client' },
                result => {
                    onFinish(result.find(u => u.email === values.email));
                },
                ['contractor']
            );
        });
    }

    handleDelete(job, action) {
        const { clientId, deleteJob, getClientWorkers } = this.props;
        deleteJob(job, () => {
            getClientWorkers(clientId);
            action();
        });
    }

    handleTerminate(job, action) {
        const { clientId, terminateJob, getClientWorkers } = this.props;

        terminateJob(job, () => {
            getClientWorkers(clientId);
            action();
        });
    }

    render() {
        const {
            admin,
            user,
            job,
            setImpersonateRole,
            setRoleSelectorVisibility,
            workerId,
            tab,
            contractorId,
            projects,
            users,
            projectsOptions,
            clientId
        } = this.props;

        if (!user) return null;

        const assignmentTab = {
            title: <FormattedMessage {...messages.assignment} />,
            content: (
                <AssignmentTab
                    roleType={'admin'}
                    job={job}
                    handleDelete={(job, action) => this.handleDelete(job, action)}
                    handleTerminate={(job, action) => this.handleTerminate(job, action)}
                    projects={projects}
                    projectsOptions={projectsOptions}
                    users={users}
                    reload={this.loadWorkers}
                    clientId={clientId}
                    inviteUser={this.inviteUser}
                    admin={admin}
                />
            )
        };

        const tabs = [
            { title: <FormattedMessage {...messages.contact} />, content: <GeneralTab roleType={'admin'} job={job} user={user} /> },
            assignmentTab,
            { title: <FormattedMessage {...messages.documents} />, content: <DocumentsTab roleType={'admin'} job={job} contractorId={contractorId} /> },
            {
                title: <FormattedMessage {...messages.pay} />,
                content: <PayStubsTab roleType={'admin'} job={job} workerId={workerId} contractorId={contractorId} />
            },
            { title: <FormattedMessage {...messages.banking} />, content: <BankingTab roleType={'admin'} job={job} contractorId={contractorId} /> }
        ];

        return (
            <div className="row">
                <div className="impersonate-button">
                    <i className="material-icons" onClick={() => setImpersonateRole(user, role => setRoleSelectorVisibility(true, { role }))}>
                        visibility
                    </i>
                </div>
                <div className="col-xs-12">
                    <Tabs items={tabs} pageWide title={getFullName(user)} isPageTitle={true} defaultTab={tab} />
                </div>
            </div>
        );
    }
}

AdminWorker.defaultProps = {
    clientId: undefined,
    contractorId: undefined,
    workerId: undefined
};

AdminWorker.propsTypes = {
    clientId: PropTypes.string.isRequired,
    contractorId: PropTypes.string.isRequired,
    workerId: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => {
    const { workerId, contractorId } = props;
    let user = state.users.list ? state.users.list.find(u => u.id === workerId) : undefined;
    let job = state.clients.workers ? state.clients.workers.find(w => w.contractor_id === contractorId) : undefined;
    const projects = state.projects.list;
    const projectsOptions = (projects || []).map(p => ({ value: p.id, label: p.name }));
    const admin = state.users.adminDetails;
    return {
        admin,
        user,
        job,
        projectsOptions,
        usersInclude: state.users.listInclude,
        users: (state.users.list || []).filter(user => user.account_type !== 'contractor'),
        projects: state.timekeeping.projects
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            deleteJob,
            terminateJob,
            getJobs,
            getClientWorkers,
            getUsersInclusive,
            setImpersonateRole,
            setRoleSelectorVisibility,
            getJobProjects,
            getClientsProjects,
            sendInvite
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AdminWorker);



// WEBPACK FOOTER //
// ./src/pages/worker/tenants/admin.jsx